import axios from 'axios';

export const qaService = {
    listErrors,
	setQA,
	switchQAError
};

function listErrors(orderId) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/qa/"+orderId, {params: {}});
}

function setQA(orderId, qaResult) {
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'QA_OK': qaResult}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/qa/"+orderId, body, headers);
}

function switchQAError(errorId, enabled) {
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'enabled': enabled}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/qa/switch/"+errorId, body, headers);
}